module.exports = __webpack_public_path__ + "img/ic_zk.af9b7343.svg";